import { render, staticRenderFns } from "./DialogAttachmentForm.vue?vue&type=template&id=cb8df3f4&scoped=true&"
import script from "./DialogAttachmentForm.vue?vue&type=script&lang=js&"
export * from "./DialogAttachmentForm.vue?vue&type=script&lang=js&"
import style0 from "./DialogAttachmentForm.vue?vue&type=style&index=0&id=cb8df3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8df3f4",
  null
  
)

export default component.exports